/* COLLECTIVE MINDLABS — i18n (BG default in DOM, EN from map) */
(function () {
  'use strict';
  var LANGKEY = 'collective_lang';
  function cur() { try { var l = localStorage.getItem(LANGKEY); return l === 'en' ? 'en' : 'bg'; } catch (e) { return 'bg'; } }

  var EN = {
    'announce': 'DROP 001 IS BACK ✦ <b>WILL YOU GUESS RIGHT?</b> BOX A / B / C ✦ OPEN &amp; INSPECT AT ECONT BEFORE YOU PAY ✦ SHIPS IN 24H ✦ HAND-PICKED ARCHIVE ✦&nbsp;',
    'nav.boxes': 'BOXES', 'nav.how': 'HOW IT WORKS', 'nav.faq': 'FAQ',
    'cta.pickSm': 'PICK A BOX', 'cta.pick': 'PICK A BOX →', 'cta.open': 'OPEN →',
    'footer.loc': 'SOFIA, BG · HAND-PICKED ARCHIVE', 'footer.ig': 'IG @COLLECTIVE.MINDLABS',
    'footer.shipping': 'SHIPPING', 'footer.contact': 'CONTACT', 'capsule': 'SECRET CAPSULE',

    'hero.eyebrow': 'COLLECTIVE · DROP 001 IS BACK',
    'hero.h1': 'Pick a box. Did you guess what’s inside?',
    'hero.sub': 'Streetwear mystery boxes from the archive. Pick box A, B or C — you know neither the count nor what drops. Open and inspect at the Econt office before you pay a cent.',
    'hero.micro1': 'hand-picked archive · open &amp; inspect before you pay',
    'hero.micro2': 'Trusted by 250+ customers',

    'proof.rating': '4.8 AVG · 250+ CUSTOMERS · 2K COMMUNITY',

    'how.eyebrow': 'ZERO-RISK MYSTERY', 'how.h2': 'How it works',
    'how.s1t': '1 · PICK A BOX', 'how.s1p': 'Choose a tier, then box A, B or C, and enter your size.',
    'how.s2t': '2 · WE CURATE BY HAND', 'how.s2p': 'Real archive pieces, matched to your size.',
    'how.s3t': '3 · OPEN &amp; INSPECT', 'how.s3p': 'At the Econt office you see everything before you pay.',
    'how.s4t': '4 · KEEP IT OR LEAVE IT', 'how.s4p': 'Not for you? Leave it at the office. Zero risk.',

    'boxes.eyebrow': 'DROP 001 · GUESS RIGHT?', 'boxes.h2': 'Place your bet',
    'boxes.sub': 'One decision. We handle the rest — sized, sealed, shipped in 24h.',
    'belt.gamble': 'BOX A / B / C · 2, 3 OR 4 PIECES',
    'belt.jackpot': 'A / B / C · 3, 5 OR 8 PREMIUM PIECES',
    'belt.firstbell': 'BACK TO SCHOOL · 1 OR 2 FITS',
    'desc.gamble': 'Guess right? Pick box A, B or C and get 2, 3 or 4 hand-picked streetwear pieces. The pure gamble.',
    'desc.jackpot': 'Higher quality, better brands. Pick A, B or C and take 3, 5 or 8 premium pieces. The big bet.',
    'desc.firstbell': 'No gamble. 1 fit (top + bottom) for €35 or 2 fits for €65. You know exactly what you get.',
    'badge.top': 'JACKPOT', 'firstbell.from': 'from',
    'belts.line': 'Every piece is hand-picked from the archive. <b>Open and inspect at the Econt office before you pay.</b>',

    'value.eyebrow': 'THE MATH', 'value.h2': 'More inside than on the price tag.',
    'value.sub': 'Even on the smallest bet, the value inside beats the price.',
    'value.v1': 'You pay <b>€49</b> · inside 2–4 pieces worth far more. Box A, B or C — guess right?',
    'value.v2': 'You pay <b>€89</b> · inside 3, 5 or 8 premium pieces. Better brands, bigger bet.',
    'value.v3': 'You pay <b>€35 / €65</b> · a guaranteed fit, no gamble — 1 or 2 sets in your size.',

    'norisk.eyebrow': 'NOTHING TO LOSE', 'norisk.h2': 'You literally can’t get burned.',
    'nr1t': 'OPEN IT BEFORE YOU PAY', 'nr1p': 'Check everything at the Econt office. Don’t like it? Leave it there.',
    'nr2t': 'SIZE-MATCHED', 'nr2p': 'Every piece — matched to your top size and waist.',
    'nr3t': 'SHIPS IN 24H', 'nr3p': 'Tracked delivery via Econt — with a tracking number.',
    'nr4t': 'REAL PEOPLE', 'nr4p': 'DM us on Instagram — a real person replies fast.',

    'reviews.eyebrow': 'REVIEWS', 'reviews.h2': 'The archive has fans.',
    'reviews.agg': '<span class="stars">★★★★★</span> 4.8 from 250+ buyers · 2K community',
    'ig.strip': 'AS SEEN ON <a href="https://instagram.com/collective.mindlabs" target="_blank" rel="noopener">@COLLECTIVE.MINDLABS</a>',
    'brands.label': 'Brands that might drop',

    'urgency.eyebrow': 'WHY EARLY MATTERS', 'urgency.h2': 'Most pieces are single finds.',
    'urgency.sub': 'When one sells, that exact heat is gone. This below is our warehouse. Live.',
    'urgency.live': 'LIVE FROM THE WAREHOUSE · EVERYONE SEES THE SAME',
    'urgency.of': 'BOXES<br>STILL UP FOR GRABS',
    'urgency.note': 'Everyone on this site is watching the same numbers, in real time. <b>When they hit 0 — the box closes.</b>',

    'faq.eyebrow': 'STRAIGHT ANSWERS', 'faq.h2': 'FAQ',
    'faq.q1': 'HOW DOES THE A / B / C GAMBLE WORK?', 'faq.a1': 'On THE GAMBLE and THE JACKPOT you pick box A, B or C. The count is a secret — GAMBLE gives 2, 3 or 4, JACKPOT gives 3, 5 or 8. You don’t know if they’re tops or bottoms either. That’s the fun.',
    'faq.q2': 'CAN I SEE WHAT’S INSIDE BEFORE I PAY?', 'faq.a2': 'Yes. Choose Econt office delivery and open your parcel there before you pay. Not happy? Leave it and pay nothing.',
    'faq.q3': 'HOW IS SIZING GUARANTEED?', 'faq.a3': 'You enter gender, top size and waist. Every piece is picked to those sizes. On GAMBLE / JACKPOT you can also choose “tops only”.',
    'faq.q4': 'WHAT IS BACK TO SCHOOL?', 'faq.a4': 'A no-gamble set: 1 fit (1 top + 1 bottom) for €35 or 2 fits (2+2) for €65. You know exactly what you get.',
    'faq.q5': 'WHAT BRANDS CAN I EXPECT?', 'faq.a5': 'Nike, Adidas, Stüssy, Supreme, Vans, Levi’s, The North Face, Champion, Thrasher, Carhartt, Tommy Hilfiger, Fendi, Louis Vuitton, Gallery Dept. and more.',
    'faq.q6': 'HOW FAST DOES IT SHIP?', 'faq.a6': 'Within 24 hours, tracked via Econt.',

    'founder.eyebrow': 'BEHIND THE BRAND', 'founder.h2': 'One team. One archive.',
    'founder.p1': 'The idea was born mid-thrift. The best part was never the piece — it was the anticipation. The mystery of what might surface.',
    'founder.p2': 'DROP 001 sold out in days. So we’re coming back — same archive, new finds, same feeling.',
    'founder.p3': 'You’re not buying from a faceless store — a real person stands behind every box, with one goal: to make your style more one-of-one.',

    'final.h2': 'Stop scrolling.<br>Place your bet.',
    'email.head': 'WANT EARLY ACCESS TO THE NEXT DROP? NO SPAM.', 'email.ph': 'your@email.com', 'email.btn': 'SIGN ME UP',

    'pdp.back': '‹ ALL BOXES', 'pdp.add': 'ADD TO CART →',
    'pdp.t1t': 'OPEN &amp; TEST', 'pdp.t1p': 'Inspect at Econt before you pay.',
    'pdp.t2t': 'SIZE-MATCHED', 'pdp.t2p': 'Every piece to your size.',
    'pdp.t3t': 'SHIPS IN 24H', 'pdp.t3p': 'Tracked delivery via Econt.',
    'pdp.t4t': 'REAL PEOPLE', 'pdp.t4p': 'DM us on Instagram anytime.'
  };

  var baseline = null;
  function capture() {
    baseline = { text: {}, ph: {} };
    document.querySelectorAll('[data-i18n]').forEach(function (el) { var k = el.getAttribute('data-i18n'); if (baseline.text[k] == null) baseline.text[k] = el.innerHTML; });
    document.querySelectorAll('[data-i18n-ph]').forEach(function (el) { baseline.ph[el.getAttribute('data-i18n-ph')] = el.getAttribute('placeholder') || ''; });
  }
  function pick(lang, base, k) { return lang === 'en' ? (EN[k] != null ? EN[k] : base[k]) : base[k]; }
  function apply(lang) {
    if (!baseline) capture();
    document.querySelectorAll('[data-i18n]').forEach(function (el) { var v = pick(lang, baseline.text, el.getAttribute('data-i18n')); if (v != null) el.innerHTML = v; });
    document.querySelectorAll('[data-i18n-ph]').forEach(function (el) { var v = pick(lang, baseline.ph, el.getAttribute('data-i18n-ph')); if (v != null) el.setAttribute('placeholder', v); });
    document.documentElement.setAttribute('lang', lang);
    document.querySelectorAll('[data-lang-toggle]').forEach(function (b) { b.textContent = lang === 'en' ? 'БГ' : 'EN'; });
  }
  function set(lang) { try { localStorage.setItem(LANGKEY, lang); } catch (e) {} apply(lang); try { window.dispatchEvent(new CustomEvent('collective:lang', { detail: { lang: lang } })); } catch (e) {} }
  function toggle() { set(cur() === 'en' ? 'bg' : 'en'); }
  function init() { capture(); apply(cur()); document.addEventListener('click', function (e) { if (e.target.closest('[data-lang-toggle]')) { e.preventDefault(); toggle(); } }); }
  window.COLLECTIVE_I18N = { set: set, toggle: toggle, current: cur };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
